import React from 'react'
import moment from 'moment-timezone'
import { useTranslation } from 'react-i18next'

import styles from './volunteerList.module.scss'

const formatTimeAgo = date => {
  if (!date) return ''
  return moment(date).fromNow()
}

export default function VolunteerInfo({ volunteer, isTaskLeader }) {
  const { t } = useTranslation()
  
  return (
    <div className={styles.volunteerInfo}>
      <img
        className={styles.profilePic}
        src={
          volunteer.user?.media_attachment?.direct_upload_url ||
          '/images/default-user.png'
        }
        alt={volunteer.user?.name || 'Volunteer'}
      />
      <div className={styles.volunteerDetails}>
        <div className={styles.volunteerName}>{volunteer.user?.name || 'Unknown'}</div>
        {volunteer.role ? (
          isTaskLeader ? (
            <div className={styles.volunteerRole}>
              <span className="badge badge-purple">
                {t('VolunteerListScreen.task_leader', 'Task Leader')}
              </span>
            </div>
          ) : (
            <div className={styles.volunteerRole}>{volunteer.role}</div>
          )
        ) : (
          <div className={styles.volunteerTime}>
            {formatTimeAgo(volunteer.created_at)}
          </div>
        )}
      </div>
    </div>
  )
}

